import { Bottle, BottleType } from '../../domain/entities';
import { BackendBouteille, BOTTLE_TYPE_MAPPING, BOTTLE_TYPE_REVERSE_MAPPING } from '../models/backend-models';

// Convertit une bouteille du backend vers le modèle frontend
export const mapBackendBottleToFrontend = (backendBottle: BackendBouteille): Bottle => {
  console.log('🔄 Mapper - Bouteille backend reçue:', backendBottle);
  
  try {
    const mapped = {
      id: backendBottle.reference, // Utilise reference comme ID
      name: backendBottle.name,
      type: BOTTLE_TYPE_MAPPING[backendBottle.type] as BottleType || 'RED',
      year: backendBottle.annee ? parseInt(backendBottle.annee, 10) : undefined,
      description: backendBottle.description || '',
      rating: backendBottle.note || 0,
      isGift: backendBottle.occasion === 1, // 1 = cadeau
      isPrivate: backendBottle.share === 'false', // Si share=false, alors privé
      imageUrl: backendBottle.picture,
      createdAt: backendBottle.dateCreation ? new Date(backendBottle.dateCreation) : new Date(),
      archivedAt: backendBottle.dateBu && backendBottle.dateBu > 0 ? new Date(backendBottle.dateBu) : undefined,
      archiveComment: backendBottle.commentaire,
      isArchived: backendBottle.status === 'ARCHIVE',
      userId: backendBottle.bouteilleUserId.toString()
    };
    
    console.log('🔄 Mapper - Bouteille mappée:', mapped);
    return mapped;
  } catch (error) {
    console.error('🔄 Mapper - Erreur lors du mapping:', error);
    console.error('🔄 Mapper - Bouteille problématique:', backendBottle);
    throw error;
  }
};

// Convertit une bouteille du frontend vers le format backend
export const mapFrontendBottleToBackend = (frontendBottle: Bottle): any => {
  return {
    reference: frontendBottle.id,
    name: frontendBottle.name,
    type: BOTTLE_TYPE_REVERSE_MAPPING[frontendBottle.type] || 1,
    annee: frontendBottle.year?.toString(),
    description: frontendBottle.description,
    note: frontendBottle.rating,
    occasion: frontendBottle.isGift ? 1 : 0,
    share: frontendBottle.isPrivate ? 'false' : 'true',
    commentaire: frontendBottle.archiveComment
  };
};